<template>
    <LayoutDefault>
        <div class="container-fluid banner-plb pb-5 f-play-cover"
            :style="[{ backgroundImage: `url(${images_fpt(landingInfo.bannerPage, landingInfo.bannerMob)})` }]"
            :class="[checkMobile() ? 'fptplay-banner__background-size--cover' : '']">
            <section-banner :title="landingInfo.pageTitle" :description="landingInfo.pageDescription"></section-banner>

            <section-type-fptplay v-if="subscribedPackages.length > 0" message="FPT Play - Gói thuê bao" :textColor="entColor"
                idSection="fpt-play-sub" :tabs="subscribedPackages" :loading="loading" :optionQuantity="optionQuantity"
                :label="landingInfo" v-model="selectedSubscribedTab" @onProgress="onProgress(0)" @get-meta="getMetaSeo">
                <div :slot="tab.CmsContent.system_name" v-for="(tab, tabIndex) in subscribedPackages" class="row gutter-24"
                    :key="`section-choose-package-fptplay-${tabIndex}-${tab.CmsContent.system_name}`">
                    <!-- info image -->
                    <div class="col-lg-6" v-if="tab.CmsContent.content">
                        <div class="image-box">
                            <img v-if="!checkMobile()" v-bind:src="images_fpt(tab.CmsContent.content.fptplay_image_path, tab.CmsContent.content.fptplay_image_path_mobile)" />
                        </div>
                    </div>

                    <!-- info detail -->
                    <div class="col-lg-6">
                        <div class="info">
                            <div class="col-12" v-if="tab.CmsContent.content">
                                <img style="width: 100%"
                                    v-bind:src="images_fpt(tab.CmsContent.content.fptplay_channel_path, tab.CmsContent.content.fptplay_channel_mobile_path)" />
                            </div>
                            <ul class="list-service">
                                <li class="fptplay-text__font-weight-400" v-for="(detail, detailIndex) in tab.CmsContent.content.features"
                                    :key="`tab-${tabIndex}-detail-${detailIndex}`">
                                    <p class="m-0" v-text="detail.fptplay_feature_description"></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section-type-fptplay>
            <SectionTypeSekeleton v-else>
                <template #body>
                    <div class="d-flex box flex-column flex-md-row">
                        <!-- info image -->
                        <b-skeleton-img card-img="left" width="400px" height="300px"></b-skeleton-img>
                        <!-- info detail -->
                        <div class="flex-fill">
                            <b-skeleton-table :rows="7" :columns="2"></b-skeleton-table>
                        </div>
                    </div>
                </template>
            </SectionTypeSekeleton>
            <section-type-fptplay style="margin-block-start: 40px" v-if="entertainingPackages.length > 0"
                message="Gói giải trí" idSection="fpt-play" :tabs="entertainingPackages" :loading="loading"
                :optionQuantity="optionQuantity" :label="landingInfo" v-model="selectedEntertainingTab"
                :textColor="entColor" @onProgress="onProgress(1)" @get-meta="getMetaSeo">
                <div :slot="tab.CmsContent.system_name" v-for="(tab, tabIndex) in entertainingPackages" class="row gutter-24"
                    :key="`section-choose-package-fptplay-${tabIndex}-${tab.CmsContent.system_name}`">
                    <!-- info image -->
                    <div class="col-lg-6" v-if="tab.CmsContent.content">
                        <div class="image-box">
                            <img v-if="!checkMobile()" v-bind:src="images_fpt(tab.CmsContent.content.fptplay_image_path, tab.CmsContent.content.fptplay_image_path_mobile)" />
                        </div>
                    </div>

                    <!-- info detail -->
                    <div class="col-lg-6">
                        <div class="info">
                            <div class="col-12" v-if="tab.CmsContent.content">
                                <img style="width: 100%"
                                    v-bind:src="images_fpt(tab.CmsContent.content.fptplay_channel_path, tab.CmsContent.content.fptplay_channel_mobile_path)" />
                            </div>
                            <ul class="list-service">
                                <li v-for="(detail, detailIndex) in tab.CmsContent.content.features"
                                    :key="`tab-${tabIndex}-detail-${detailIndex}`">
                                    <p class="fptplay-text__font-weight-400 m-0" v-text="detail.fptplay_feature_description"></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section-type-fptplay>
            <SectionTypeSekeleton v-else>
                <template #body>
                    <div class="d-flex box flex-column flex-md-row">
                        <!-- info image -->
                        <b-skeleton-img card-img="left" width="400px" height="300px"></b-skeleton-img>
                        <!-- info detail -->
                        <div class="flex-fill">
                            <b-skeleton-table :rows="7" :columns="2"></b-skeleton-table>
                        </div>
                    </div>
                </template>
            </SectionTypeSekeleton>
        </div>

        <HomeSlider />
        <!-- BLOCK SUPPORT -->
        <section class="sec-support mb-4">
            <div class="container bg-white bdrd-12">
                <div class="row">
                    <div class="col-12 px-4 pt-4">
                        <!-- headline -->
                        <h4 class="text-16 text-bold mb-3 d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <i class="d-block mr-3 ico-orange">
                                    <svg width="16" height="21" viewBox="0 0 16 21" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M5.5 4.41797H10.5C11.053 4.41797 11.5 4.86497 11.5 5.41797C11.5 5.97097 11.053 6.41797 10.5 6.41797H5.5C4.947 6.41797 4.5 5.97097 4.5 5.41797C4.5 4.86497 4.947 4.41797 5.5 4.41797ZM6.5 14.918C6.5 14.09 7.172 13.418 8 13.418C8.828 13.418 9.5 14.09 9.5 14.918C9.5 15.746 8.828 16.418 8 16.418C7.172 16.418 6.5 15.746 6.5 14.918ZM14 17.418C14 17.97 13.552 18.418 13 18.418H3C2.448 18.418 2 17.97 2 17.418V3.41797C2 2.86597 2.448 2.41797 3 2.41797H13C13.552 2.41797 14 2.86597 14 3.41797V17.418ZM13 0.417969H3C1.346 0.417969 0 1.76397 0 3.41797V17.418C0 19.072 1.346 20.418 3 20.418H13C14.654 20.418 16 19.072 16 17.418V3.41797C16 1.76397 14.654 0.417969 13 0.417969Z"
                                            fill="#FF8840" />
                                    </svg>
                                </i>
                                <span>Các thiết bị hỗ trợ</span>
                            </div>
                        </h4>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col kd-fptplay-box" v-for="(icon, index) in iconSupport" :key="index">
                        <div class="text-center">
                        <img class="kd-fptplay-img" width="30" height="30" :src="asset_img(icon.src)"
                                alt="Icon fptplay" />
                            <p class="text-med text-12 mt-3 mb-4" v-text="icon.label"></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container p-0">
                <img v-if="landingPageBanner" class="mw-100"
                    :src="images_fpt(landingPageBanner.src, landingPageBanner.src_mob)" :alt="landingPageBanner.alt" />
            </div>
        </section>
        <!--   <News style="margin-left:10px;margin-bottom:55px"></News> -->
        <!-- <section-footer></section-footer> -->
    </LayoutDefault>
</template>
<script>
import LayoutDefault from '@/layouts/LayoutDefault';
import SectionTypeFptplay from '../../../mycore/components/SectionTypeFptplay.vue';
import SectionBanner from '../../../mycore/components/SectionBanner.vue';
import HomeSlider from '../component/homeSlider.vue';
import isMobile from '@/mycore/utils/mobile-detect';
import News from '../../../mycore/components/SectionCategoryNews.vue';
import SectionTypeSekeleton from '../../../mycore/components/SectionTypeSekeleton.vue';
import {
    MAX_QUANTITY,
    MIN_QUANTITY,
    SERVICE_CODE,
    PAYMENT_FLOW,
    DEFAULT_FPTPLAY_DATA
} from '../../../configs/constants';
import * as api_sp from '../module/api-sp';
import * as cms from '../../../mycore/module/cms';
import { mapGetters } from 'vuex';
import { mixins } from '../../mixin';

export default {
    mixins: [mixins],
    components: {
        LayoutDefault,
        SectionBanner,
        SectionTypeFptplay,
        HomeSlider,
        News,
        SectionTypeSekeleton
    },
    computed: {
        ...mapGetters('fptplay', ['landingPageBanner']),
    },
    data() {
        return {
            entColor: 'black'/* this.checkMobile() ? 'white' : 'black' */,
            loading: true,
            landingInfo: {
                pageTitle: 'FPT Play',
                pageDescription: 'Truyền hình trực tuyến trên mọi nền tảng',
                buyNow: 'Mua ngay',
                bannerPage: '',
                bannerMob: '',
            },
            listMeta: {},
            iconSupport: [
                {
                    label: 'Web',
                    src: '/htmlv4-4/assets/images/icon/icon-web.png',
                },
                {
                    label: 'TV',
                    src: '/htmlv4-4/assets/images/icon/icon-tv.png',
                },
                {
                    label: 'TV Box',
                    src: '/htmlv4-4/assets/images/icon/icon-box.png',
                },
                {
                    label: 'Android',
                    src: '/htmlv4-4/assets/images/icon/icon-android.png',
                },
                {
                    label: 'IOS',
                    src: '/htmlv4-4/assets/images/icon/icon-ios.png',
                },
            ],
            selectedSubscribedTab: 0,
            selectedEntertainingTab: 0,
            optionQuantity: {
                maxValue: MAX_QUANTITY,
                minValue: MIN_QUANTITY,
            },
            sectionTabsData: DEFAULT_FPTPLAY_DATA,
            entertainingPackages: [],
            subscribedPackages: [],
            serviceCode: SERVICE_CODE.FPTPLAY,
            urlPaymentFlow: PAYMENT_FLOW.FPTPLAY,
            cachedDataloaded: false,
        };
    },
    mounted() {
        this.loadMeta();
        this.clearSession();
        this.load();
        localStorage.removeItem("clearedSession"); // Xoá cờ để tránh lặp
    },
    created() {
        // xu ly khi du lieu parse khong dung
        try {
            this.listMeta = JSON.parse(localStorage.getItem('meta_seo'));
        } catch (e) {};
        sessionStorage.isPage = 'FptPlay';
    },
    methods: {
        load() {
            let address = this.getFromCache('dataLocation') ||
                this.getFromSessions('dataLocation') || {
                locationid: 8,
                districtid: 1,
                wardid: 1,
            };
            let locationId = address.locationid;
            let districtId = address.districtid;
            let wardId = address.wardid;
            cms.getLandingBanner(this.mappingInfoLandingPage, this.serviceCode);
            api_sp.getCategories(
                6,
                parseInt(locationId),
                parseInt(districtId),
                parseInt(wardId),
                sessionStorage.SourceType || 1,
                this.getCategoriesCallback
            );
            if (this.$route.query.utm_source) {
                sessionStorage.utm_source = this.$route.query.utm_source || '';
                sessionStorage.utm_medium = this.$route.query.utm_medium || '';
                sessionStorage.utm_campaign = this.$route.query.utm_campaign || '';
                sessionStorage.utm_term = this.$route.query.utm_term || '';
                sessionStorage.utm_content = this.$route.query.utm_content || '';
            }
            if (this.$route.query.aff_sid) {
                sessionStorage._aff_sid = this.$route.query.aff_sid || '';
                const d = new Date();
                d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
                let expires = 'expires=' + d.toUTCString();
                // document.cookie = '_aff_sid' + '=' + this.$route.query.aff_sid + ';' + expires + ';path=/';
            }
            if (this.$route.query.ref) {
                sessionStorage.ref = this.$route.query.ref || '';
            }
        },
        loadMeta() {
            const item = window.location.pathname.split('/').pop();
            if (item) {
                this.getMetaSeo(item);
            } else {
                this.getMetaSeo('fpt-play');
            }
        },
        checkMobile() {
            return isMobile();
        },
        getMetaSeo($e) {
            if (Object.keys(this.listMeta).length > 0) {
                let key_service = Object.keys(this.listMeta);
                for (let i = 0; i < key_service.length; i++) {
                    if ($e && key_service[i] == $e) {
                        document.title = this.listMeta[key_service[i]].title;
                        document.getElementsByTagName('meta')['keywords'].content =
                            this.listMeta[key_service[i]].keywords;
                        document.getElementsByTagName('meta')['description'].content =
                            this.listMeta[key_service[i]].description;
                        //
                        document.querySelector('meta[property="og:url"]').setAttribute(
                            'content',
                            this.serviceCode == $e
                                ? window.location.origin + `/${this.serviceCode}`
                                : window.location.origin + `/${this.serviceCode}/${$e}`
                        );
                        document.querySelector('meta[property="og:type"]').setAttribute('content', 'article');
                        document
                            .querySelector('meta[property="og:title"]')
                            .setAttribute('content', this.listMeta[key_service[i]].title);
                        document
                            .querySelector('meta[property="og:description"]')
                            .setAttribute('content', this.listMeta[key_service[i]].description);
                        document
                            .querySelector('meta[property="og:image"]')
                            .setAttribute('content', this.listMeta[key_service[i]].thumbnail);
                    }
                }
            }
        },
        getServiceFromUrl() {
            const serviceCode = this.$route.params.servicecode;
            const subLength = this.subscribedPackages.length;
            const entLength = this.entertainingPackages.length;
            const subFirstTab = subLength > 0 ? this.subscribedPackages[0].CmsContent.system_name : '';
            const entFirstTab = entLength > 0 ? this.entertainingPackages[0].CmsContent.system_name : '';
            if (serviceCode && typeof serviceCode != 'undefined') {
                const subcribedData = this.subscribedPackages.find((i) => i.CmsContent.route_name == serviceCode);
                const entertainData = this.entertainingPackages.find((i) => i.CmsContent.route_name == serviceCode);
                if (!subcribedData && !entertainData) {
                    if (this.cachedDataloaded) {
                        this.$router.replace({ name: 'homepage.notFound' })
                    }
                    this.cachedDataloaded = true
                }
                if (subcribedData) {
                    this.cachedDataloaded = true;
                    return ([this.selectedSubscribedTab, this.selectedEntertainingTab] = [
                        subcribedData.CmsContent.system_name,
                        entFirstTab,
                    ]);
                }
                if (entertainData) {
                    this.cachedDataloaded = true;
                    return ([this.selectedEntertainingTab, this.selectedSubscribedTab] = [
                        entertainData.CmsContent.system_name,
                        subFirstTab,
                    ]);
                }
            }
            return ([this.selectedSubscribedTab, this.selectedEntertainingTab] = [subFirstTab, entFirstTab]);
        },
        mappingInfoLandingPage: function (isSuccess, data, error) {
            if (isSuccess && data.error === 0) {
                const content = data.data;
                this.landingInfo = {
                    ...this.landingInfo,
                    pageTitle: content.landing_page_title,
                    pageDescription: content.landing_page_subtitle,
                    bannerPage: content.landing_page_banner_path,
                    bannerMob: content.landing_page_banner_mobile_path,
                    buyNow: 'Mua ngay',
                };
                this.addToCache('fptplayInfo', this.landingInfo);
            }
        },
        getCategoriesCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    let resp = data.data
                    if(resp){
                        this.subscribedPackages = resp.fptplay_offnet
                        this.entertainingPackages = resp.fptplay_sa
                    }
                    this.getServiceFromUrl()
                    this.$store.dispatch('system/updateLoading', false);
                    this.loading = false;
                } else {
                    this.hasCateError();
                }
            } else {
                this.hasCateError();
            }
        },
        hasCateError() {
            this.entertainingPackages.forEach((e) => (e.packages = []));
            this.subscribedPackages.forEach((s) => (s.packages = []));
            this.loading = false;
            this.$store.dispatch('system/updateLoading', false);
        },
        clearSession() {
            this.$store.dispatch('ultraFast/clearSession');
            this.$store.dispatch('fptplay/clearSession');
            this.$store.dispatch('fptplaybox/clearSession');
            this.$store.dispatch('camera/clearSession');
            this.$store.dispatch('cloud/clearSession');
            this.$store.dispatch('internet/clearSession');
            this.$store.dispatch('fsafe_go_extend/clearSession');
        },
        //flag dùng để xác định group
        onProgress(flag) {
            const packageList = [this.subscribedPackages, this.entertainingPackages];
            const tabList = [this.selectedSubscribedTab, this.selectedEntertainingTab];
            const listSessionName = ['keyProduct', 'countSub'];
            for (let i = 0; i < listSessionName.length; i++) {
                if (sessionStorage[listSessionName[i]]) {
                    sessionStorage.removeItem(listSessionName[i]);
                }
            }
            const tab = packageList[flag].find((tab) => tab.CmsContent.system_name === tabList[flag]);
            this.$store.dispatch('fptplay/updateSelectedPackage', tab);
            this.$store.dispatch('fptplay/updateOrderNumber', null);
            this.$router
                .push({ name: 'fptplay.registerWithSCode', params: { servicecode: tab.CmsContent.route_name } })
                .catch(() => { });
        },
    },
};
</script>
<style scoped>
.kd-fptplay-img {
    width: 30px !important;
}
.kd-fptplay-box {
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.fptplay-text__font-weight-400 {
    font-weight: 400 !important;
}
</style>
